module.exports = __webpack_public_path__ + "static/media/galeryVinyl7.31eaec7c.jpg";